import React from 'react'

export default function LogoView() {
    return (
        <div className="logo">
            aaa
        </div>
    )
}
